<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" sm="10" md="8">
        <v-card-title class="themed-card-title">
          Request Access
        </v-card-title>
        <v-card-text>
          <v-stepper
            v-model="stepper"
            :vertical="true"
            :style="{ 'box-shadow': 'none' }"
          >
            <!-- Step 1 -->
            <!-- license agreement -->
            <v-stepper-step
              key="step-header-1"
              :complete="stepper > 1"
              :step="1"
            >
              Review License Agreement
            </v-stepper-step>

            <v-stepper-content key="step-content-1" :step="1">
              <v-card-text>
                <h3 class="mb-3">
                  Please read carefully the following license agreement
                </h3>
                <div
                  v-html="$store.state.websiteVariables.licenseAgreement"
                ></div>
              </v-card-text>

              <v-checkbox
                :ripple="false"
                v-model="agreed"
                label="I have read the License Agreement and accept the terms."
              ></v-checkbox>

              <v-btn
                color="accent"
                :disabled="!agreed"
                @click="agreed ? (stepper = 2) : null"
              >
                Continue
              </v-btn>
            </v-stepper-content>

            <!-- Step 2 -->
            <!-- Reasons for data access -->
            <v-stepper-step
              key="step-header-2"
              :complete="stepper > 2"
              :step="2"
            >
              Access request justification
            </v-stepper-step>
            <v-stepper-content key="step-content-2" :step="2">
              <v-card-text>
                <access-justification
                  @justificationComplete="stepper = 3"
                ></access-justification>
              </v-card-text>
            </v-stepper-content>

            <!-- Step 3 -->
            <!-- Account creation -->
            <v-stepper-step
              key="step-header-3"
              :complete="stepper > 3"
              :step="3"
            >
              Create account
            </v-stepper-step>
            <v-stepper-content key="step-content-3" :step="3">
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" sm="10" lg="8">
                    <create-account
                      @registrationComplete="stepper = 4"
                    ></create-account>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-stepper-content>

            <!-- Step 4 -->
            <!-- Registration complete -->
            <v-stepper-step
              key="step-header-4"
              :complete="stepper > 4"
              :step="4"
            >
              Registration complete
            </v-stepper-step>
            <v-stepper-content key="step-content-4" :step="4">
              <v-card-text>
                <p class="success--text">
                  Your registration has been successfully completed and your
                  request is now under review.
                </p>
                <p>
                  A verification email has been sent to your email address.
                  Please make sure to check your inbox and follow the
                  instructions, as it is essential prior to data access.
                </p>
                <router-link to="application-status"
                  >You can click here to review the status of your
                  application.</router-link
                >
                <p></p>
              </v-card-text>
            </v-stepper-content>
          </v-stepper>
        </v-card-text>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CreateAccount from "./CreateAccount";
import AccessJustification from "./AccessJustification";

export default {
  components: {
    CreateAccount,
    AccessJustification
  },
  data: () => ({
    stepper: 1,
    agreed: false
  })
};
</script>
